import { render, staticRenderFns } from "./skuSetting.vue?vue&type=template&id=4b88c286&scoped=true&"
import script from "./skuSetting.vue?vue&type=script&lang=js&"
export * from "./skuSetting.vue?vue&type=script&lang=js&"
import style0 from "./skuSetting.vue?vue&type=style&index=0&id=4b88c286&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b88c286",
  null
  
)

export default component.exports